export const SimulacaoContentSkeleton = () => {
  return (
    <div className="bg-foreground border-muted border p-6" data-testid="skeleton-simulacao-content">
      <div className="mb-6 flex items-center justify-between">
        <div className="flex flex-col gap-4">
          <div className="h-5 w-48 animate-pulse rounded bg-neutral-200" />
          <div className="flex flex-col gap-1 space-x-2 md:flex-row md:gap-0 md:divide-x [&>*]:pr-2">
            <div className="h-4 w-24 animate-pulse rounded bg-neutral-200" />
            <div className="h-4 w-32 animate-pulse rounded bg-neutral-200" />
          </div>
        </div>
        <div className="hidden md:block">
          <div className="h-10 w-32 animate-pulse rounded bg-neutral-200" />
        </div>
      </div>
      <div className="mb-0">
        <div className="flex h-14 items-center bg-neutral-200 px-6">
          <div className="h-4 w-40 animate-pulse rounded bg-neutral-300" />
        </div>
        <div className="border-border space-y-4 overflow-hidden rounded-none border-r border-l px-6 py-5">
          <div className="border-muted flex flex-col overflow-hidden border-b pb-4">
            <div className="mb-2 h-4 w-16 animate-pulse rounded bg-neutral-200" />
            <div className="h-5 w-48 animate-pulse rounded bg-neutral-200" />
          </div>
          <div className="sm:border-border grid grid-cols-12 items-start gap-4 sm:pb-2">
            <div className="border-muted col-span-12 flex flex-col border-b pb-4 sm:col-span-4 sm:border-r sm:border-b-0 sm:pb-0">
              <div className="mb-2 h-4 w-32 animate-pulse rounded bg-neutral-200" />
              <div className="h-5 w-40 animate-pulse rounded bg-neutral-200" />
            </div>
            <div className="border-muted col-span-12 flex flex-col border-b pb-4 sm:col-span-4 sm:border-r sm:border-b-0 sm:pb-0">
              <div className="mb-2 h-4 w-28 animate-pulse rounded bg-neutral-200" />
              <div className="h-5 w-36 animate-pulse rounded bg-neutral-200" />
            </div>
            <div className="border-muted col-span-12 flex flex-col border-b pb-4 sm:col-span-4 sm:border-none sm:pb-0">
              <div className="mb-2 h-4 w-20 animate-pulse rounded bg-neutral-200" />
              <div className="h-5 w-24 animate-pulse rounded bg-neutral-200" />
            </div>
          </div>
          <div className="border-muted grid grid-cols-12 items-start gap-4 border-t pt-4 sm:pb-2">
            <div className="border-muted col-span-12 flex flex-col border-b pb-4 sm:col-span-4 sm:border-r sm:border-b-0 sm:pb-0">
              <div className="mb-2 h-4 w-32 animate-pulse rounded bg-neutral-200" />
              <div className="h-5 w-40 animate-pulse rounded bg-neutral-200" />
            </div>
            <div className="border-muted col-span-12 flex flex-col border-b pb-2 sm:col-span-4 sm:border-r sm:border-b-0 sm:pb-0">
              <div className="mb-2 h-4 w-28 animate-pulse rounded bg-neutral-200" />
              <div className="h-5 w-36 animate-pulse rounded bg-neutral-200" />
            </div>
            <div className="border-muted col-span-12 flex flex-col border-b pb-2 sm:col-span-4 sm:border-none sm:pb-0">
              <div className="mb-2 h-4 w-20 animate-pulse rounded bg-neutral-200" />
              <div className="h-5 w-24 animate-pulse rounded bg-neutral-200" />
            </div>
          </div>
        </div>
      </div>
      <div className="mb-16 sm:mb-6">
        <div className="flex items-center justify-between bg-neutral-200 p-4">
          <div className="h-4 w-36 animate-pulse rounded bg-neutral-300" />
          <div className="hidden sm:block">
            <div className="h-8 w-40 animate-pulse rounded bg-neutral-300" />
          </div>
        </div>
        <div className="border-border mb-6 space-y-3 overflow-hidden border-r border-b border-l px-6 py-5">
          <div className="border-muted flex flex-col overflow-hidden border-b pb-2">
            <div className="mb-2 h-4 w-32 animate-pulse rounded bg-neutral-200" />
            <div className="h-5 w-40 animate-pulse rounded bg-neutral-200" />
          </div>
          <div className="sm:gap-b-4 sm:border-muted grid grid-cols-12 items-start gap-4 sm:gap-x-0 sm:gap-y-4 sm:border-b sm:pb-2">
            <div className="border-muted col-span-12 flex flex-col border-b pb-2 sm:col-span-4 sm:border-r sm:border-b-0 sm:pb-0">
              <div className="mb-2 h-4 w-20 animate-pulse rounded bg-neutral-200" />
              <div className="h-5 w-32 animate-pulse rounded bg-neutral-200" />
            </div>
            <div className="border-muted col-span-12 flex flex-col border-b pb-2 sm:col-span-8 sm:border-r-0 sm:border-b-0 sm:pb-0 sm:pl-4">
              <div className="mb-2 h-4 w-16 animate-pulse rounded bg-neutral-200" />
              <div className="h-5 w-36 animate-pulse rounded bg-neutral-200" />
            </div>
          </div>
          <div className="sm:gap-b-4 sm:border-muted grid grid-cols-12 items-start gap-4 sm:gap-x-0 sm:gap-y-4 sm:border-b sm:pb-2">
            <div className="border-muted col-span-12 flex flex-col border-b pb-2 sm:col-span-4 sm:border-r sm:border-b-0 sm:pb-0">
              <div className="mb-2 h-4 w-16 animate-pulse rounded bg-neutral-200" />
              <div className="h-5 w-28 animate-pulse rounded bg-neutral-200" />
            </div>
            <div className="border-muted col-span-12 flex flex-col border-b pb-2 sm:col-span-8 sm:border-r-0 sm:border-b-0 sm:pb-0 sm:pl-4">
              <div className="mb-2 h-4 w-20 animate-pulse rounded bg-neutral-200" />
              <div className="h-5 w-32 animate-pulse rounded bg-neutral-200" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
